import {
  IsString,
  IsOptional,
  IsDate,
  IsBoolean,
  IsArray,
  IsInt,
  ValidateNested,
  IsNotEmpty,
} from "class-validator";
import { Type } from "class-transformer";
import { CustomerContactDto } from "./customer-contact.dto";

export class ContractDto {
  @Type(() => Date)
  @IsDate()
  @IsNotEmpty()
  start_date: Date;

  @IsInt()
  duration_months: number;

  @IsOptional()
  @Type(() => Date)
  @IsDate()
  renewal_date?: Date;

  @IsBoolean()
  auto_renew: boolean;

  @IsArray()
  @IsString({ each: true })
  account_managers: string[]; // list of OneRiver people

  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => CustomerContactDto)
  contacts?: CustomerContactDto[];
}
